/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useState,useContext, useCallback, useEffect, useRef} from 'react'
import ImageSizeTooltip from '../../components/ProfileImageUpload/imageSizeTooltip'
import GlobalContext from '../../components/Context/GloablContext';
import Input from '../../components/InputBox';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { validateEmail } from '../../CommonMethods/EmailValidator';
import UpdateButton from '../../components/UpdateButton';
import { dataService } from '../../services/data.services';
import { AddBranch } from '../../redux/GlobalSlice';
import { useDispatch } from 'react-redux';
import { hanldeBranch } from '../auth/authSlice';
import UploadFileInput from '../../components/UploadFileInput';
import Toast from '../../components/Toast';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import { StateList } from '../../components/Helper/StateList';
import CardHeader from '../../components/CardHeader';
import { FetchBranch } from '../../CommonMethods/FetchBranch';
import { generateFinancialYears } from '../../CommonMethods/CurrentAcademicYear';
import CustomOverLay from '../../components/CustomOverlay';

export default function OnboardNewBranch({edit}) {
    const {id} = useParams()
    const panCardRegex=/[A-Z]{5}[0-9]{4}[A-Z]{1}/
    const dispatch = useDispatch()
    const navigate =useNavigate()
    const location = useLocation();
    const { state: myRedirection } = location;
    const [loading, setloading] = useState(false);
    const [loadingPage,setLoadingPage]=useState(true)
    const [submitSelected, setsubmitSelected] = useState(false);
    const [imageLoading, setimageLoading] = useState('')
    const [formatError, setformatError] = useState('')
    const {setToastmessage, isBranchUpdate, setIsBranchUpdate} =useContext(GlobalContext)
    const [stateStatus,setStateStatusDisable]=useState(true)
    const academicRef = useRef();
    const [showFinacialYear, setshowFinacialYear] = useState(false)
    const financilaYearRef=useRef();
    const [GSTError, setGSTError] = useState([])
    const initialState={
        "registration_12a_certificate_number":'',
        "registration_12a_file_url":'',
        "registration_80g_certificate_number":'',
        "registration_80g_file_url":'',
        "registration_10_23c_certificate_number":'',
        "registration_10_23c_file_url":'',
        "approval_number":'',
        "approval_registration_file_url":'',
        "pf_registration_certificate_number":'',
        "pf_registration_file_url":'',
        "esi_registration_certificate_number":'',
        "esi_registration_file_url":'',
        "pt_registration_certificate_number":'',
        "pt_registration_file_url":'',
        "tan_number":'',
        "tan_file_url":'',
        "pan_file_url":'',
        "pan_number":'',
        "gst_file_url": "",
        "gst_number": "",
        "poc_email_address": "",
        "poc_mobile_number": "",
        "poc_name" : "",
        "address_line_1" : "",
        "address_line_2" : "",
        "area": "",
        "state" : "",
        "pincode" : "",
        "starting_financial_year":"",
        "city" : "",
        "branch_name":"",
        "clock_in_out_facitilty" : false,
        'starting_financial_year':''
    }

    const [customError, setcustomError] = useState([])
    const excepKeys=['uploadGstin','Gstin']
    const mandatoryKeys={
        "poc_email_address": "",
        "poc_mobile_number": "",
        "address": "",
        "branch_name":"",
        "pan_file_url":'',
        "pan_number":'',
        "address_line_1" : "",
        "address_line_2" : "",
        "area": "",
        "state" : "",
        "starting_financial_year":"",
        "pincode" : "",
        "city" : "",
        "clock_in_out_facitilty" : false,
        'starting_financial_year':''
    }
    const [state, setstate] = useState(initialState);
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [isAcademicYear, setIsAcademicYear] = useState(false);

    /* The above code is using the `useOnClickOutside` hook in a React component. This hook is used to
    detect when a click event occurs outside of a specified element (`financilaYearRef` in this
    case). When a click event is detected outside of the element, the `setshowFinacialYear` function
    is called to set the `showFinacialYear` state to `false`. */
    useOnClickOutside(financilaYearRef,()=>{
        setshowFinacialYear(false)
    })

    /**
     * The function `handleValidation` checks if all the mandatory keys in the `state` object have
     * non-empty values and returns true if they do, otherwise it returns false.
     * @returns The function `handleValidation` returns a boolean value. It returns `true` if there are
     * no errors (i.e., if the `ErrorArray` is empty), and `false` otherwise.
     */
    const handleValidation=()=>{
        
        const ErrorArray=[]
        Object.keys(mandatoryKeys).map((key)=>{
            if(state[key]===''){
                ErrorArray.push(key)
            }
        })
        setcustomError(ErrorArray)
        return ErrorArray?.length===0
    }

    /**
     * The function `handlePanCheck` checks if the value of `state.pan_number` matches a regular
     * expression for a PAN card number.
     * @returns The function `handlePanCheck` is returning the result of the
     * `panCardRegex.test(state.pan_number)` expression.
     */
    const handlePanCheck=()=>{
        return panCardRegex.test(state.pan_number)
    }
    
    /**
     * The function `createPayload` creates a payload object by filtering out certain keys from the
     * `state` object and removing the `starting_financial_year` key if `edit` is true.
     * @returns The function `createPayload` returns the `body` object.
     */
    const createPayload=()=>{
        const body={}
        Object.keys(state).filter((val)=>!excepKeys.includes(val)).map((key)=>{
            if(state[key]!==''){
                body[key]=state[key]
            }
        })
        if(edit){
            delete body.starting_financial_year
        }
        return body;

    }

    /* The above code is a JavaScript React component that defines a function called `handleFetch`.
    This function is using the `useCallback` hook to create a memoized version of the function. */
    const handleFetch =useCallback(
        async() => {
            let response = await dataService.GetAPI(`branch/${id}`);
            if(response.data.status===200){
                const Getdata=response.data.data
                setLoadingPage(false)
                setstate({
                    "registration_12a_certificate_number":Getdata.registration_12a_certificate_number || '',
                    "registration_12a_file_url":Getdata.registration_12a_file_url || '',
                    "registration_80g_certificate_number":Getdata.registration_80g_certificate_number || '',
                    "registration_80g_file_url":Getdata.registration_80g_file_url || '',
                    "registration_10_23c_certificate_number":Getdata.registration_10_23c_certificate_number || '',
                    "registration_10_23c_file_url":Getdata.registration_10_23c_file_url || "",
                    "approval_number":Getdata.approval_number || '',
                    "approval_registration_file_url":Getdata.approval_registration_file_url || '',
                    "pf_registration_certificate_number":Getdata.pf_registration_certificate_number || '',
                    "pf_registration_file_url":Getdata.pf_registration_file_url || '',
                    "esi_registration_certificate_number":Getdata.esi_registration_certificate_number || '', 
                    "esi_registration_file_url":Getdata.esi_registration_file_url || '',
                    "pt_registration_certificate_number":Getdata.pt_registration_certificate_number || '',
                    "pt_registration_file_url":Getdata.pt_registration_file_url|| '', 
                    "tan_number":Getdata.tan_number || '',
                    "tan_file_url":Getdata.tan_file_url || '',
                    "pan_file_url":Getdata.pan_file_url || '',
                    "pan_number":Getdata.pan_number || '',
                    "gst_file_url": Getdata.gst_file_url || '',
                    "gst_number": Getdata.gst_number || '',
                    "poc_email_address": Getdata.poc_email_address || '',
                    "poc_mobile_number": Getdata.poc_mobile_number || '',
                    "poc_name" : Getdata.poc_name || '',
                    "address_line_1" : Getdata.address_line_1 || '',
                    "address_line_2" : Getdata.address_line_2 || '',
                    "area": Getdata.area || '',
                    "state" : Getdata.state || '',
                    "pincode" : (Getdata.pincode).toString() || '',
                    "city" : Getdata.city || '',
                    "starting_financial_year":Getdata.starting_financial_year||'',
                    "branch_name":Getdata.branch_name || '',
                    "clock_in_out_facitilty" : Getdata.clock_in_out_facitilty
                })
                // setstate(Getdata)
            }
        },
        [id],
    )
    
    /* The above code is using the useEffect hook in a React component. It is setting up a side effect
    that will be triggered whenever the "edit" variable changes. If the "edit" variable is true, it
    will call the "handleFetch" function. The "handleFetch" function is passed as a dependency to
    the useEffect hook, so it will be re-evaluated whenever the "handleFetch" function changes. */
    useEffect(() => {
        if(edit)
            handleFetch()
    }, [handleFetch])

    /**
     * The function `handleAllValidation` checks for various validations on different fields and
     * returns a flag indicating if any validation failed.
     * @returns a boolean value. If any of the validation checks fail, the flag variable will be set to
     * true and the function will return true. Otherwise, it will return false.
     */
    const handleAllValiadation = () => {
        let flag = false
        const array = ['pincode', 'poc_email_address', 'poc_mobile_number', 'pan_number']
        let allArray = []
        array.forEach((item) => {
            switch (item) {
            case "pan_number":
                if(!handlePanCheck()) {
                    flag = true;   
                    allArray.push(item)  
                }
                break;
            case "poc_email_address":
                if(validateEmail(state.poc_email_address)) {
                    flag = true;  
                    allArray.push(item)  
                }
                break;
            case "poc_mobile_number":
                if((state.poc_mobile_number?.length <10) || (state.poc_mobile_number?.length > 10)) {
                    flag = true;  
                    allArray.push(item) 
                }
                break;
            case "pincode":
                if(state.pincode === undefined && state.pincode?.length !== 6) {
                    flag = true;  
                    allArray.push(item)    
                }
                break;   
            default:
                break;
            }
        })
        setcustomError(allArray);
        return flag
        
    }
    
    /**
     * The `handleSubmit` function is used to handle form submission in a React component, performing
     * validation on the form fields and making an API request to either update or create a branch.
     * @returns The function `handleSubmit` does not have a return statement.
     */
    const handleSubmit=async(e)=>{
        e.preventDefault()
        setloading(true)
        setsubmitSelected(true);
        if(!handleValidation()){
            setToastErrorMessage("Please fill in all the mandatory fields") 
            setloading(false)
            return
        }
        
        if(handleAllValiadation()){
            setloading(false)
            setToastErrorMessage("Please enter valid details") 
            return
        }
        try {
            let endpoint;
            let Payload=createPayload()
            let response
            if(edit) {
                endpoint=`branch/${id}`
                response = await dataService.PatchAPI(Payload,endpoint);
            } else {
                endpoint=`branch`
                response = await dataService.PostAPI(Payload,endpoint);
            }
            if (response.data.status===201 || response.error === false) {
                const allbraches =await FetchBranch()
                if(allbraches?.length===1){
                    const mydata= allbraches
                    const branchNameWithStatus = state.branch_name +((mydata.status!=undefined&&!mydata.status)?" (Inactive)":"");
                    localStorage.setItem('branch_details',JSON.stringify({name:mydata[0].name,id:mydata[0].id, status:mydata[0].status, branchNameWithStatus:branchNameWithStatus}));
                    dispatch(AddBranch(allbraches))
                } 
                dispatch(hanldeBranch(allbraches));
                if(edit)
                {
                    const branchDetails = JSON.parse(localStorage.getItem('branch_details'));
                    const bid = branchDetails?.id;
                    const matchedBranch = allbraches.find(item => item.id === bid);
                    if(id === bid && state.branch_name !== branchDetails?.branch_name){
                        setIsBranchUpdate(!isBranchUpdate)
                        const isInactive = (matchedBranch.status!=undefined&&!matchedBranch.status);
                        const branchNameWithStatus = state.branch_name +(isInactive?" (Inactive)":"");
                        localStorage.setItem('branch_details',JSON.stringify({name:state.branch_name,id:id, status:!isInactive, branchNameWithStatus:branchNameWithStatus}));
                    }
                    const queryString = window.location.search;
                    const searchParams = new URLSearchParams(queryString);
                    if(myRedirection?.redirect === 'fromListingScreen'){
                        navigate(`/manage-branches?${searchParams?.toString()}`)
                    } else {
                        navigate(`/manage-branches/${id.split('*')[0]}*branch_details`)
                    }
                    setloading(false);
                }
                else{
                    if(allbraches?.length===1){
                        navigate('/')
                    } else{
                        navigate('/manage-branches')
                    }
                    setloading(false);
                }
                setToastmessage(`Branch ${edit ? 'updated': 'onboarded'} successfully`)
                if(allbraches?.length===1 && !edit){
                    setTimeout(()=>{
                        window.location.reload(); // Refresh the page
                    }, 2500)
                } else {
                    setloading(false);
                }
            }
            else {
                setloading(false);
                setToastErrorMessage(response.data.data.message)
            }
        } catch (error) {
            setloading(false);
            setToastErrorMessage(error?.response?.data?.message || 'Something went wrong')
            if(error?.response?.data?.message === 'Length of GSTIN should be 15'){
                setGSTError(['gst_number'])
            }
        }

    }
    
    /**
     * The handleInput function updates the state with the value of the input field and converts the
     * value to uppercase if the input field has an id of "pan_number".
     */
    const handleInput=(e)=>{
        setGSTError([])
        setToastErrorMessage('')
        let {id,value}=e.target
        if(id === "pan_number") {
            value = value.toUpperCase();
        }
        setstate((prv)=>({
            ...prv,
            [id]:value
        }))
    }

    /* The above code is a JavaScript React component that defines a function called `getAddress`. This
    function is defined using the `useCallback` hook. */
    const getAddress =useCallback(
        async()=>{
            if(state.pincode?.length<6 ){
                setstate((prv)=>({
                    ...prv,
                    "state":'',
                    "city":''
                }))  
            }
            if(state.pincode?.length===6){
                try {
                    const res =await dataService.GetAPI(`institution/get-city-state/${state.pincode}`);
                    
                    const stateCopy={...state};
                    stateCopy.city=res.data.data.city;
                    stateCopy.state=res.data.data.state;
                  
                    if(res?.data?.data?.state === "" || res?.data?.data?.state === undefined) {
                        setStateStatusDisable(false);
                         
                    }
                    else{
                        setStateStatusDisable(true)
                        
                    }
                    setstate(stateCopy)
                } catch (error) {
                    setStateStatusDisable(false);
                    // setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                    // setMandatoryErrorMessage(error?.response?.data?.message)
                }
            }
        },
        [state.pincode],
    )
    
    /* The above code is using the useEffect hook in React to call the getAddress function. The
    useEffect hook is used to perform side effects in functional components, such as fetching data
    or subscribing to events. In this case, the getAddress function is being called when the
    component mounts or when the getAddress function changes. */
    useEffect(() => {
        getAddress()
    }, [getAddress])

    /* The above code is using the `useOnClickOutside` hook in a React component. It is passing in a
    reference to an element (`academicRef`) and a callback function that will be called when a click
    event occurs outside of that element. In the callback function, it is setting the state variable
    `isAcademicYear` to `false`. */
    useOnClickOutside(academicRef, () => {
        setIsAcademicYear(false)
    });   

    /**
     * The function `handleSelectYear` updates the state with the selected financial year and hides the
     * financial year selection.
     */
    const handleSelectYear=(val)=>{
        setshowFinacialYear(false)
        setstate((prv)=>({
            ...prv,
            "starting_financial_year":val,
        }))
        setshowFinacialYear(false)

    }

    /**
     * The `cancelHandler` function navigates to different URLs based on certain conditions.
     */
    const cancelHandler = () => {
        const queryString = window.location.search;
        const searchParams = new URLSearchParams(queryString);
        if(edit){
            if(myRedirection?.redirect === 'fromListingScreen'){
                navigate(`/manage-branches?${searchParams?.toString()}`)
            } else {
                navigate(`/manage-branches/${id.split('*')[0]}*branch_details`)
            }
        } else{ 
            navigate(`/manage-branches`)
        }
    }

    const [imageSizeInfoHover, setImageSizeInfoHover] = useState(false)
    const handleImageToggle = () => {
        // Use the functional form of setState
        setImageSizeInfoHover((prevIsToggled) => !prevIsToggled);
    };

    return (
        <CardHeader noPadding>
            <div
                className="mainDataCntnrTop shadow-s13"
                style={{ position: "sticky", position: "-webkit-sticky" }}
            >
                <h5 className="pageHeader adderror">
                    {edit ? "Edit" : "Onboard"} Branch
                </h5>
                <div className="flex items-center">
                    <button
                        type="button"
                        onClick={() => cancelHandler()}
                        className="cancl-btn"
                    >
                        Cancel
                    </button>
                    <UpdateButton
                        ButtonName={edit ? "Update" : "Add"}
                        loading={loading}
                        handleOnCLick={handleSubmit}
                        classKey="actn-btn onboardInstitution"
                    />
                </div>
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            {edit && loadingPage && <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>}
            {(!edit || (edit && !loadingPage)) && <div className="mainDataCntnrPageDiv scrollBlue_thick">
                <div className="w-[90%] mx-auto">
                    <div className="border border-[#D0D5DD] p-3 rounded">
                        <div className="flex -mx-10">
                            <div className="w-[52%] px-10">
                                <div className="w-full">
                                    <div
                                        className="flex items-center mb-4"
                                        //  onClick={()=>dispatch(AddBranch([]))}
                                    >
                                        <label
                                            htmlFor="branch_name"
                                            className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex"
                                        >
                                            Branch Name
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            state={state}
                                            id="branch_name"
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            isMandatoryField={true}
                                            text="Branch name is mandatory"
                                            placeholder="Enter Branch Name" 
                                        />
                                    </div>
                                    <div className="flex items-center mb-4">
                                        <label
                                            htmlFor="address_line_1"
                                            className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex"
                                        >
                                            Address Line 1
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            state={state}
                                            id="address_line_1"
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            isMandatoryField={true}
                                            text="Address Line 1 name is mandatory"
                                            placeholder="Enter Address Line 1"
                                        />
                                    </div>
                                    <div className="flex items-center mb-4">
                                        <label
                                            htmlFor="address_line_2"
                                            className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex"
                                        >
                                            Address Line 2
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            state={state}
                                            id="address_line_2"
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            isMandatoryField={true}
                                            text="Address Line 2 name is mandatory"
                                            placeholder="Enter Address Line 2"
                                        />
                                    </div>
                                    <div className="flex items-center mb-4">
                                        <label
                                            htmlFor="pincode"
                                            className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex"
                                        >
                                            PIN Code
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            state={state}
                                            id="pincode"
                                            maxLength={6}
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            inputWidth={'w-[40%]'}
                                            isMandatoryField={true}
                                            text="PIN Code is mandatory"
                                            placeholder="Enter PIN Code"
                                            customError={customError}
                                        />
                                    </div>
                                    <div className="flex items-center mb-4">
                                        <label
                                            htm="area"
                                            className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex"
                                        >
                                            Area
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            state={state}
                                            id="area"
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            inputWidth={'w-[40%]'}
                                            isMandatoryField={true}
                                            placeholder="Enter Area"
                                            text="PIN Code is mandatory"
                                        />
                                    </div>
                                    <div className="flex items-center mb-4">
                                        <label
                                            htmlFor="city"
                                            className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex"
                                        >
                                            City
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            state={state}
                                            id="city"
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            inputWidth={'w-[40%]'}
                                            isMandatoryField={true}
                                            placeholder="Enter City"
                                            text="PIN Code is mandatory"
                                        />
                                    </div>
                                    <div className="flex items-center">
                                        <label
                                            htmlFor="state"
                                            className="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex"
                                        >
                                            State
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <div
                                            ref={academicRef}
                                            class="relative w-[40%]"
                                            data-te-dropdown-ref=""
                                        >
                                            <button
                                                disabled={stateStatus}
                                                onClick={() => setIsAcademicYear(!isAcademicYear)}
                                                class={`slct-inpt-fld ${
                                                    submitSelected && state.state === ""
                                                        ? "redBorder"
                                                        : ""
                                                }  ${stateStatus?'bg-[#E6E8EA]':''} transition duration-150 ease-in-out err-border1`}
                                                type="button"
                                                id="dropdownMenu_acdemic_year"
                                                data-te-dropdown-toggle-ref=""
                                                aria-expanded="false"
                                            >
                                                <p
                                                    class={`text-f2 ${
                                                        state.state === ""
                                                            ? "text-[#818E98]"
                                                            : "text-[#101828]"
                                                    } font-normal`}
                                                >
                                                    {state.state === ""
                                                        ? "Select State"
                                                        : state.state}
                                                </p>
                                                <img
                                                    src="/images/dropdown-icon.png"
                                                    loading="lazy"
                                                    alt="icon"
                                                    class={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${
                                                        isAcademicYear ? "transform rotate-180" : ""
                                                    }`}
                                                />
                                            </button>
                                            {isAcademicYear && (
                                                <ul
                                                    class="slct_drp_dwn  w-[250px] max-h-[220px] overflow-auto scroll-bar min-w-full [&amp;[data-te-dropdown-show]]:block shadow-s6 max-h-[150px] overflow-auto"
                                                    aria-labelledby="dropdownMenu_acdemic_year"
                                                    data-te-dropdown-menu-ref=""
                                                >
                                                    {StateList.map((item) => (
                                                        <li key={item}>
                                                            <p
                                                                onClick={() => {
                                                                    setIsAcademicYear(false);
                                                                    setstate((prv) => ({
                                                                        ...prv,
                                                                        state: item,
                                                                    }));
                                                                }}
                                                                class="slct_drp_dwn_optn"
                                                                id="year"
                                                                href="#"
                                                                data-te-dropdown-item-ref=""
                                                            >
                                                                {item}
                                                            </p>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-[48%] px-10">
                                <div className="w-full">
                                    <div className="flex items-center mb-4">
                                        <label
                                            htmlFor="poc_name"
                                            className="text-f7 font-normal text-[#031624] min-w-[185px] inline-flex"
                                        >
                                            Point of Contact Name
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            state={state}
                                            id="poc_name"
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            isMandatoryField={true}
                                            placeholder="Enter POC Name"
                                            text="State is mandatory"
                                        />
                                    </div>
                                    <div className="flex items-center mb-4">
                                        <label
                                            htmlFor="poc_email_address"
                                            className="text-f7 font-normal text-[#031624] min-w-[185px] inline-flex"
                                        >
                                            POC Email Address
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            state={state}
                                            id="poc_email_address"
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            isMandatoryField={true}
                                            placeholder="Enter POC Email Address"
                                            customError={customError}
                                        />
                                    </div>
                                    <div className="flex items-center pb-4 border-b border-[#95C0E0]">
                                        <label
                                            for="poc_mobile_number"
                                            className="text-f7 font-normal text-[#031624] min-w-[185px] inline-flex"
                                        >
                                            POC Mobile Number
                                            <span class="req-fld-astrk">*</span>
                                        </label>
                                        <Input
                                            type="text"
                                            state={state}
                                            id="poc_mobile_number"
                                            maxLength={10}
                                            customError={customError}
                                            handleInput={handleInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            isMandatoryField={true}
                                            placeholder="Enter POC Mobile No."
                                        />
                                    </div>
                                    
                                    <div class="flex items-center py-4">
                                        <label for="poc_phone_number" class="text-f7 font-normal text-[#031624] min-w-[185px] inline-flex">Starting Financial Year<span class="req-fld-astrk">*</span></label>
                                        <div class="relative w-full" data-te-dropdown-ref="">
                                            <button  disabled={edit}  onClick={()=>{
                                                setsubmitSelected(false)
                                                setshowFinacialYear(!showFinacialYear);
                                            }} class={`${submitSelected&&state.starting_financial_year===''?' redBorder':''} slct-inpt-fld transition duration-150 ease-in-out shadow-s12 ${edit ? 'bg-[#E6E8EA]' : 'bg-white'}`} type="button" id="financial_year" data-te-dropdown-toggle-ref="" aria-expanded="false">
                                                <p class={`text-f7 text-normal more-lines ${state.starting_financial_year===''?'text-[#818E98]':'text-[#101828]'} `}>{state.starting_financial_year===''?'Select FY':state.starting_financial_year}</p>
                                                <img src="/images/dropdown-icon.png" alt="icon" class={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 pl-1 ${showFinacialYear?'transform rotate-180':''}`}/>
                                            </button>
                                            {showFinacialYear &&<ul ref={financilaYearRef}  class={`slct_drp_dwn min-w-full [&amp;[data-te-dropdown-show]]:block`} aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref="" >
                                                <li class="max-h-[150px] overflow-auto scroll-bar">
                                                    <ul>{
                                                        generateFinancialYears().map((val,i)=>(
                                                            <li key={i} onClick={()=>handleSelectYear(val)}>
                                                                <a class="block w-full whitespace-nowrap bg-white px-1.5 mb-2 text-f7 font-normal text-[#031624]" href="javascript:void(0)" data-te-dropdown-item-ref="">
                                                                    {val}
                                                                </a>
                                                            </li>
                                                        ))}</ul>
                                                </li>
                                            
                                            </ul>}
                                        </div>
                                        <div class="relative self-end ml-2" style={{'top': '-6px'}}>
                                            <ImageSizeTooltip
                                                handleImageToggle={handleImageToggle}
                                                imageSizeInfoHover={imageSizeInfoHover}
                                                imgtransform={'scale(2.5)'}
                                                tooltipFor={'Onboard_Branch_FY'}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex items-center relative">
                                        <label
                                            for="clock_in_out"
                                            className="switch text-f7 font-normal text-[#031624] inline-flex slider"
                                        >
                                            Clock-in/Clock-out Facility
                                        </label>
                                        <div className="status custom-toggle flex items-center">
                                            <label
                                                className="switch"
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    id="clock_in_out_facitilty"
                                                    checked={state.clock_in_out_facitilty}
                                                    onChange={() =>
                                                        setstate((prv) => ({
                                                            ...prv,
                                                            clock_in_out_facitilty:
                                !state.clock_in_out_facitilty,
                                                        }))
                                                    }
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                            <p className="ml-1.5">
                                                <span
                                                    className={`text-f7 font-normal ${
                                                        state.clock_in_out_facitilty
                                                            ? "text-[#106EB4] switch_enabled"
                                                            : " text-[#344054] disable_switch"
                                                    }`}
                                                >
                                                    {state.clock_in_out_facitilty
                                                        ? "Enable"
                                                        : "Disable"}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-[30px]">
                    <h5 className="text-lg font-semibold text-[#000000] mb-2">
                        Statutory Details
                    </h5>
                    <div className="border border-[#D0D5DD] rounded p-3">
                        <div className="-mx-[27px] flex flex-wrap">
                            <div className="px-[20px] w-1/2 mb-2">
                                <div className="w-full">
                                    <div className="flex items-center -mx-2">
                                        <div className="w-[70%] px-2">
                                            <div className="flex items-center">
                                                <label
                                                    for="pan-field"
                                                    className="text-f7 font-normal text-[#031624] w-[45%] inline-flex pan_uploaded"
                                                >
                                                    PAN
                                                    <span class="req-fld-astrk">*</span>
                                                </label>
                                                <Input
                                                    type="text"
                                                    state={state}
                                                    id="pan_number"
                                                    maxLength={10}
                                                    handleInput={handleInput}
                                                    submitSelected={submitSelected}
                                                    setsubmitSelected={setsubmitSelected}
                                                    isMandatoryField={true}
                                                    text="PAN is mandatory"
                                                    placeholder="Enter PAN"
                                                    customError={customError}
                                                />
                                            </div>
                                        </div>
                                        <div className="px-2" style={{'width':'24%'}}>
                                            <div>
                                                <UploadFileInput
                                                    mainKey="branch"
                                                    state={state}
                                                    id="pan_file_url"
                                                    keyName="PAN"
                                                    setsubmitSelected={setsubmitSelected}
                                                    submitSelected={submitSelected}
                                                    formatError={formatError}
                                                    setstate={setstate}
                                                    text="PAN is mandatory"
                                                    setformatError={setformatError}
                                                    setimageLoading={setimageLoading}
                                                    placeholder="Upload PAN"
                                                    imageLoading={imageLoading}
                                                    
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-[20px] w-1/2 mb-4">
                                <div className="w-full">
                                    <div className="flex items-center -mx-2">
                                        <div className="w-[70%] px-2">
                                            <div className="flex items-center">
                                                <label
                                                    htmlFor="registration_10_23c_certificate_number"
                                                    className="text-f7 font-normal text-[#031624] w-[75%] inline-flex 10reg_uploaded"
                                                >
                                                    10(23C) Reg. No.
                                                </label>
                                                <Input
                                                    optional
                                                    type="text"
                                                    state={state}
                                                    maxLength={18}
                                                    id="registration_10_23c_certificate_number"
                                                    handleInput={handleInput}
                                                    submitSelected={submitSelected}
                                                    setsubmitSelected={setsubmitSelected}
                                                    
                                                    placeholder="Enter 10(23C) Reg. No."
                                                    text="10(23C) Registration is mandatory"
                                                />
                                            </div>
                                        </div>
                                        <div className="px-2" style={{'width':'24%'}}>
                                            <UploadFileInput
                                                optional
                                                mainKey="branch"
                                                state={state}
                                                id="registration_10_23c_file_url"
                                                keyName="10(23C) Registration Certificate"
                                                submitSelected={submitSelected}
                                                formatError={formatError}
                                                setstate={setstate}
                                                text="10(23C) Registration is mandatory"
                                                setformatError={setformatError}
                                                setimageLoading={setimageLoading}
                                                placeholder="Upload 10(23C) Registration"
                                                imageLoading={imageLoading}
                                                
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-[20px] w-1/2 mb-4">
                                <div className="w-full">
                                    <div className="flex items-center -mx-2">
                                        <div className="w-[70%] px-2">
                                            <div className="flex items-center">
                                                <label
                                                    for="gstin-field"
                                                    className="text-f7 font-normal text-[#031624] w-[45%] inline-flex gstin_uploaded"
                                                >
                                                    GSTIN
                                                </label>
                                                <Input
                                                    optional
                                                    type="text"
                                                    state={state}
                                                    id="gst_number"
                                                    maxLength={15}
                                                    handleInput={handleInput}
                                                    submitSelected={submitSelected}
                                                    setsubmitSelected={setsubmitSelected}
                                                    
                                                    text="GSTIN is mandatory"
                                                    placeholder="Enter GSTIN"
                                                    customError={GSTError}
                                                />
                                            </div>
                                        </div>
                                        <div className="px-2" style={{'width':'24%'}}>
                                            <div>
                                                <UploadFileInput
                                                    optional
                                                    mainKey="branch"
                                                    state={state}
                                                    id="gst_file_url"
                                                    keyName="GSTIN"
                                                    submitSelected={submitSelected}
                                                    formatError={formatError}
                                                    setstate={setstate}
                                                    text="GSTIN is mandatory"
                                                    setformatError={setformatError}
                                                    setimageLoading={setimageLoading}
                                                    placeholder="Upload GSTIN"
                                                    imageLoading={imageLoading}
                                                    
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-[20px] w-1/2 mb-4">
                                <div className="w-full">
                                    <div className="flex items-center -mx-2">
                                        <div className="w-[70%] px-2">
                                            <div className="flex items-center">
                                                <label
                                                    for="pf-field"
                                                    className="text-f7 font-normal text-[#031624] w-[75%] inline-flex gstin_uploaded"
                                                >
                                                    PF Reg. No.
                                                </label>
                                                <Input
                                                    optional
                                                    type="text"
                                                    state={state}
                                                    maxLength={20}
                                                    id="pf_registration_certificate_number"
                                                    handleInput={handleInput}
                                                    submitSelected={submitSelected}
                                                    setsubmitSelected={setsubmitSelected}
                                                    
                                                    placeholder="Enter PF Reg. No."
                                                />
                                            </div>
                                        </div>
                                        <div className="px-2" style={{'width':'24%'}}>
                                            <UploadFileInput
                                                optional
                                                mainKey="branch"
                                                state={state}
                                                id="pf_registration_file_url"
                                                keyName="10(23C) Registration Certificate"
                                                submitSelected={submitSelected}
                                                formatError={formatError}
                                                setstate={setstate}
                                                text="10(23C) Registration is mandatory"
                                                setformatError={setformatError}
                                                setimageLoading={setimageLoading}
                                                placeholder="Upload 10(23C) Registration"
                                                imageLoading={imageLoading}
                                                
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-[20px] w-1/2 mb-4">
                                <div className="w-full">
                                    <div className="flex items-center -mx-2">
                                        <div className="w-[70%] px-2">
                                            <div className="flex items-center">
                                                <label
                                                    for="tan-field"
                                                    className="text-f7 font-normal text-[#031624] w-[45%] inline-flex gstin_uploaded"
                                                >
                                                    TAN
                                                </label>
                                                <Input
                                                    optional
                                                    type="text"
                                                    state={state}
                                                    id="tan_number"
                                                    maxLength={10}
                                                    handleInput={handleInput}
                                                    submitSelected={submitSelected}
                                                    setsubmitSelected={setsubmitSelected}
                                                    
                                                    placeholder="Enter TAN"
                                                />
                                            </div>
                                        </div>
                                        <div className="px-2" style={{'width':'24%'}}>
                                            <UploadFileInput
                                                optional
                                                mainKey="branch"
                                                state={state}
                                                id="tan_file_url"
                                                keyName="TAN"
                                                submitSelected={submitSelected}
                                                formatError={formatError}
                                                setstate={setstate}
                                                text="TAN is mandatory"
                                                setformatError={setformatError}
                                                setimageLoading={setimageLoading}
                                                placeholder="Upload TAN"
                                                imageLoading={imageLoading}
                                                
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-[20px] w-1/2 mb-4">
                                <div className="w-full">
                                    <div className="flex items-center -mx-2">
                                        <div className="w-[70%] px-2">
                                            <div className="flex items-center">
                                                <label
                                                    htmlFor="esi_registration_certificate_number"
                                                    className="text-f7 font-normal text-[#031624] w-[75%] inline-flex gstin_uploaded"
                                                >
                                                    ESI Reg. No.
                                                </label>
                                                <Input
                                                    optional
                                                    type="text"
                                                    state={state}
                                                    maxLength={20}
                                                    id="esi_registration_certificate_number"
                                                    handleInput={handleInput}
                                                    submitSelected={submitSelected}
                                                    setsubmitSelected={setsubmitSelected}
                                                    
                                                    placeholder="Enter ESI Reg. No."
                                                />
                                            </div>
                                        </div>
                                        <div className="px-2" style={{'width':'24%'}}>
                                            <UploadFileInput
                                                optional
                                                mainKey="branch"
                                                state={state}
                                                id="esi_registration_file_url"
                                                keyName="ESI Registration Certificate"
                                                submitSelected={submitSelected}
                                                formatError={formatError}
                                                setstate={setstate}
                                                text="ESI Registration is mandatory"
                                                setformatError={setformatError}
                                                setimageLoading={setimageLoading}
                                                placeholder="Upload ESI Registration"
                                                imageLoading={imageLoading}
                                                
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-[20px] w-1/2 mb-4">
                                <div className="w-full">
                                    <div className="flex items-center -mx-2">
                                        <div className="w-[70%] px-2">
                                            <div className="flex items-center">
                                                <label
                                                    for="12a-field"
                                                    className="text-f7 font-normal text-[#031624] w-[45%] inline-flex gstin_uploaded"
                                                >
                                                    12A Reg. No.
                                                </label>
                                                <Input
                                                    optional
                                                    type="text"
                                                    state={state}
                                                    maxLength={20}
                                                    id="registration_12a_certificate_number"
                                                    // customError={!handlePanCheck()}
                                                    handleInput={handleInput}
                                                    submitSelected={submitSelected}
                                                    setsubmitSelected={setsubmitSelected}
                                                    
                                                    placeholder="Enter 12A Reg. No."
                                                />
                                            </div>
                                        </div>
                                        <div className="px-2" style={{'width':'24%'}}>
                                            <UploadFileInput
                                                optional
                                                mainKey="branch"
                                                state={state}
                                                id="registration_12a_file_url"
                                                keyName="12A Registration Certificate"
                                                submitSelected={submitSelected}
                                                formatError={formatError}
                                                setstate={setstate}
                                                text="12A Registration is mandatory"
                                                setformatError={setformatError}
                                                setimageLoading={setimageLoading}
                                                placeholder="Upload 12A Registration"
                                                imageLoading={imageLoading}
                                                
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-[20px] w-1/2 mb-4">
                                <div className="w-full">
                                    <div className="flex items-center -mx-2">
                                        <div className="w-[70%] px-2">
                                            <div className="flex items-center">
                                                <label
                                                    for="pt-field"
                                                    className="text-f7 font-normal text-[#031624] w-[75%] inline-flex gstin_uploaded"
                                                >
                                                    PT Reg. No.
                                                </label>
                                                <Input
                                                    optional
                                                    type="text"
                                                    state={state}
                                                    maxLength={20}
                                                    id="pt_registration_certificate_number"
                                                    handleInput={handleInput}
                                                    submitSelected={submitSelected}
                                                    setsubmitSelected={setsubmitSelected}
                                                    
                                                    placeholder="Enter PT Reg. No."
                                                />
                                            </div>
                                        </div>
                                        <div className="px-2" style={{'width':'24%'}}>
                                            <UploadFileInput
                                                optional
                                                mainKey="branch"
                                                state={state}
                                                id="pt_registration_file_url"
                                                keyName="PT Registration Certificate"
                                                submitSelected={submitSelected}
                                                formatError={formatError}
                                                setstate={setstate}
                                                text="PT Registration is mandatory"
                                                setformatError={setformatError}
                                                setimageLoading={setimageLoading}
                                                placeholder="Upload PT Registration"
                                                imageLoading={imageLoading}
                                                
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-[27px] w-1/2">
                                <div className="w-full">
                                    <div className="flex items-center -mx-2">
                                        <div className="w-[70%] pr-2">
                                            <div className="flex items-center">
                                                <label
                                                    for="80g-field"
                                                    className="text-f7 font-normal text-[#031624] w-[45%] inline-flex gstin_uploaded"
                                                >
                                                    80G Reg. No.
                                                </label>
                                                <Input
                                                    optional
                                                    type="text"
                                                    state={state}
                                                    maxLength={20}
                                                    id="registration_80g_certificate_number"
                                                    handleInput={handleInput}
                                                    submitSelected={submitSelected}
                                                    setsubmitSelected={setsubmitSelected}
                                                    
                                                    placeholder="Enter 80G Reg. No."
                                                />
                                            </div>
                                        </div>
                                        <div className="px-2" style={{'width':'24%'}}>
                                            <UploadFileInput
                                                optional
                                                mainKey="branch"
                                                state={state}
                                                id="registration_80g_file_url"
                                                keyName="80G Registration Certificate"
                                                submitSelected={submitSelected}
                                                formatError={formatError}
                                                setstate={setstate}
                                                text="80g Registration is mandatory"
                                                setformatError={setformatError}
                                                setimageLoading={setimageLoading}
                                                placeholder="Upload 80G Registration"
                                                imageLoading={imageLoading}
                                                
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-[27px] w-1/2">
                                <div className="w-full">
                                    <div className="flex items-center -mx-2">
                                        <div className="w-[70%] pr-2">
                                            <div className="flex items-center">
                                                <label
                                                    htmlFor="approval-field"
                                                    className="text-f7 font-normal text-[#031624] w-[75%] inline-flex gstin_uploaded"
                                                >
                                                    Approval No.
                                                </label>
                                                <Input
                                                    optional
                                                    type="text"
                                                    state={state}
                                                    maxLength={20}
                                                    id="approval_number"
                                                    handleInput={handleInput}
                                                    submitSelected={submitSelected}
                                                    setsubmitSelected={setsubmitSelected}
                                                    
                                                    placeholder="Enter Approval No."
                                                />
                                            </div>
                                        </div>
                                        <div className="px-2" style={{'width':'24%'}}>
                                            <UploadFileInput
                                                optional
                                                mainKey="branch"
                                                state={state}
                                                id="approval_registration_file_url"
                                                keyName="Approval Certificate"
                                                submitSelected={submitSelected}
                                                formatError={formatError}
                                                setstate={setstate}
                                                text="Approval is mandatory"
                                                setformatError={setformatError}
                                                setimageLoading={setimageLoading}
                                                placeholder="Upload Approval Certificate"
                                                imageLoading={imageLoading}
                                                
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </CardHeader>
    );
}
